export	const PERSONAL_ACCOUNT_HELP_DATA = [
    {
        id: "crear_perfil",
        textButton: {
            default: "Crear perfil individual",
            translationPath: "perfil.crear_perfil.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1206842808?h=623141041e&badge=0&autopause=0&player_id=0&app_id=58479",
            translationPath: "perfil.crear_perfil.url",
        },
    },
    {
        id: "asociar_institucion",
        textButton: {
            default: "Asociar una institución",
            translationPath: "perfil.asociar_institucion.titulo",
        },
        video:{
            default: "https://player.vimeo.com/video/1206842807?h=43e9b61157&badge=0&autopause=0&player_id=0&app_id=58479",
            translationPath: "perfil.asociar_institucion.url",
        },
    },

]